import { NPVR_PLAYBACK_DEVICE_TYPE, getRecordingsUrl } from 'config/api';

import {
    GetRecordingsResponse,
    RBParsedRail,
} from 'store/railsBuilder/reducer.types';
import { RecordingRailType } from 'store/recordings/actions.types';
import { RecordingStatus } from 'store/recordings/reducer.types';

import { defaultLanguage } from 'utils/Language/i18n';
import NagraInstance from 'utils/axios/nagra/DefaultInstance';

async function getRecordingsData(
    rail: RBParsedRail,
    type: RecordingRailType,
    limit: string | number = 10,
    page: number | undefined = 1,
): Promise<GetRecordingsResponse> {
    let statuses: RecordingStatus = RecordingStatus.RECORDING;
    let queryType: 'series' | 'individual' | undefined;
    let distinct: boolean | undefined;

    switch (type) {
        case RecordingRailType.RECORDED_ALL:
            statuses = RecordingStatus.RECORDING;
            break;

        case RecordingRailType.RECORDED_SINGLE:
            statuses = RecordingStatus.RECORDED;
            queryType = 'individual';
            break;
        case RecordingRailType.RECORDED_SERIES:
            statuses = RecordingStatus.RECORDED;
            queryType = 'series';
            distinct = true;
            break;

        case RecordingRailType.SCHEDULED:
            statuses = RecordingStatus.SCHEDULED;
            break;

        default:
            break;
    }

    const result = await NagraInstance.get<GetRecordingsResponse>(
        getRecordingsUrl({
            limit: Number.isNaN(Number(limit)) ? 10 : Number(limit),
            page,
            locale: defaultLanguage,
            deviceType: NPVR_PLAYBACK_DEVICE_TYPE,
            sort: rail.properties.Sorting,
            statuses,
            type: queryType,
            distinct,
        }),
    );

    return result.data;
}

export default getRecordingsData;
